import { laptopMaxXL, laptopMediumMin, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import MmcwLogo from '@propertypal/shared/src/resources/logos/millar-mccall-wylie-logo.svg';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  margin: 30px 0;
  gap: 30px;

  & > div {
    flex: 1;
  }

  @media ((${laptopMaxXL}) and (${laptopMediumMin})) {
    flex-direction: column;
  }

  @media (${tabletMax}) {
    flex-direction: column;
  }
`;

export const SponsorLogoBox = styled.button`
  background-color: white;
  margin-top: -1px;
  padding-left: 26px;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  width: 200px;
  color: ${({ theme }) => theme.textDark};

  span {
    display: inline-block;
    width: 110px;
    font-size: 12px;
    margin-left: 10px;
    text-align: left;
  }
`;

export const LegalLogo = styled(MmcwLogo)`
  width: 100%;
  max-width: 40px;
  margin-left: 5px;
`;

export const BottomRow = styled.div`
  background-color: ${({ theme }) => theme.background};
  border: 2px solid ${({ theme }) => theme.keyline};
  padding: 15px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 30px 0;

  p {
    color: ${({ theme }) => theme.textLight};
  }

  a {
    color: ${({ theme }) => theme.red};
    text-decoration: underline;
  }

  @media (${tabletMax}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const CoownershipText = styled.p`
  color: ${({ theme }) => theme.textLight};

  b {
    color: ${({ theme }) => theme.primary};
  }
`;
